import Controller from '@ember/controller';
import updateAndSaveTask from 'garaje/utils/decorators/update-and-save-task';

@updateAndSaveTask
class LocationOverviewSignInFlowsShowPlusOneController extends Controller {}

export default LocationOverviewSignInFlowsShowPlusOneController;
